"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var feature_flipper_1 = require("@shared/constants/feature-flipper");
var environment_1 = require("@shared/types/environment");
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
var Quill = window.Quill;
var HeaderFooterOptionsController = /** @class */ (function () {
    function HeaderFooterOptionsController($scope, $filter, pageLayout, 
    // @ts-ignore
    formatHelper, env, 
    // @ts-ignore
    globalOptions, 
    // @ts-ignore
    metricImperial, 
    // @ts-ignore
    QuillFormatter, pageHeaderFooterOptionsService, 
    // @ts-ignore
    PipedTextMenu) {
        var _this = this;
        this.$scope = $scope;
        this.$filter = $filter;
        this.pageLayout = pageLayout;
        this.formatHelper = formatHelper;
        this.env = env;
        this.globalOptions = globalOptions;
        this.metricImperial = metricImperial;
        this.QuillFormatter = QuillFormatter;
        this.pageHeaderFooterOptionsService = pageHeaderFooterOptionsService;
        this.PipedTextMenu = PipedTextMenu;
        this.CONTENT_FORMAT_OPTIONS = ['FONT', 'SIZE', 'COLOR'];
        this.DEFAULT_CONTENT_FORMATS = {
            FONT: 'times',
            SIZE: 10,
            COLOR: '#222222'
        };
        var translate = $filter('translate');
        this.$ctrl = this;
        $scope.$ctrl = this.$ctrl;
        var unit = globalOptions.getUnit();
        var pipedTextMenu;
        var LOADING_PIPED_TEXT = "\"innerText\":\"" + translate('PIPED_TEXT.LOADING_ELLIPSES') + "\"";
        angular_1.extend(this.$ctrl, {
            $onInit: function () {
                _this.$ctrl.customTitleLabel = _this.$ctrl.type === 'header' ? translate('HEADER_TEXT') :
                    translate('FOOTER_TEXT');
                _this.$ctrl.contentFormatsOptions = formatHelper.getSubsetFormatOptions(_this.CONTENT_FORMAT_OPTIONS);
                _this.addDefaultFormats(_this.$ctrl.contentFormatsOptions, _this.$ctrl.typeModel.customTitle.formats ||
                    _this.DEFAULT_CONTENT_FORMATS);
                _this.$ctrl.typeModel.customTitle.formats = _this.$ctrl.contentFormatsOptions;
                _this.pageHeaderFooterOptions = pageHeaderFooterOptionsService;
                _this.$ctrl.heightLabel = _this.metricImperial.getCustomLabel(translate('HEIGHT'), unit);
                if (!env.get(environment_1.ENV_VARS.BRAND_LOGO)) {
                    _this.$ctrl.typeModel.logo.type = 'CUSTOM';
                }
                _this.$ctrl.logoHeight = _this.$ctrl.typeModel.logo.height;
                if (!metricImperial.useInch(unit)) {
                    _this.$ctrl.logoHeight = _this.metricImperial.getCMOfInch(_this.$ctrl.logoHeight);
                }
            },
            loadQuillEditor: function () {
                var _this = this;
                this.$ctrl.quillObject = new Quill('#header-footer-text-editor', {
                    modules: {
                        toolbar: false
                    },
                    theme: 'snow'
                });
                this.quillFormatter = new QuillFormatter(this.$ctrl.quillObject);
                this.$ctrl.quillObject.setContents(this.pageHeaderFooterOptions.getContents(this.$ctrl.type));
                this.styleQuill();
                // This change is required because the Quill Editor has a bug when deleting the content character
                // by character. Once the last character is deleted, the Quill Editor changes the font family, color and
                // size to its default. The following lines fix that problem.
                this.$ctrl.quillObject.on('text-change', function () {
                    var currContents = _this.$ctrl.quillObject.getContents(_this.$ctrl.type);
                    _this.pageHeaderFooterOptions.setContents(_this.$ctrl.type, currContents);
                    if (_this.$ctrl.quillObject.getLength() === 1) {
                        _this.styleQuill();
                    }
                    var contentsString = JSON.stringify(currContents);
                    var isPipedTextLoading = contentsString.includes(LOADING_PIPED_TEXT);
                    if (isPipedTextLoading) {
                        _this.pageHeaderFooterOptionsService.setSaveInProgress(true);
                    }
                    else {
                        _this.pageHeaderFooterOptionsService.setSaveInProgress(false);
                    }
                });
                this.setupPipedTextMenu();
                // This adds the cursor to the end of the paragraph so when opening
                // the modal as we want to be able to delete Piped Text in the editor.
                var setCurserPosition = this.$ctrl.quillObject.getLength();
                this.$ctrl.quillObject.setSelection(setCurserPosition, setCurserPosition);
            },
            changeSelection: function () {
                if (this.$ctrl.quillObject.hasFocus()) {
                    return;
                }
                var setCurserPosition = this.$ctrl.quillObject.getLength();
                this.$ctrl.quillObject.setSelection(setCurserPosition, setCurserPosition);
            },
            updateTextFormat: function (name, value) {
                name === 'color' ? this.$ctrl.contentFormatsOptions[name.toUpperCase()].selectedColor = value :
                    this.$ctrl.contentFormatsOptions[name.toUpperCase()].selectedFormat = value;
                if (this.isQuillEditorEnabled()) {
                    this.styleQuill();
                }
            },
            setupPipedTextMenu: function () {
                var _this = this;
                pipedTextMenu = new PipedTextMenu(this.$ctrl.quillObject, '.editor', 'header-footer-text-editor');
                // @ts-ignore
                pipedTextMenu.getPipedTextMenu().then(function (menu) {
                    _this.$ctrl.pipedTextMenu = menu;
                });
            },
            getAlignmentMenu: function () {
                return lodash_1.default.merge({}, pageLayout.getAlignments());
            },
            // @ts-ignore
            getAlignmentLabel: function (alignment) {
                var alignmentMenu = pageLayout.getAlignments();
                return alignmentMenu[alignment].label;
            },
            getTextPrewViewStyle: function () {
                var format = {
                    FONT: this.$ctrl.contentFormatsOptions.FONT.selectedFormat,
                    SIZE: this.$ctrl.contentFormatsOptions.SIZE.selectedFormat,
                    COLOR: this.$ctrl.contentFormatsOptions.COLOR.selectedColor
                };
                return formatHelper.getStyles(format);
            },
            styleQuill: function () {
                this.$ctrl.quillObject.setSelection(0, this.$ctrl.quillObject.getLength());
                this.quillFormatter.setFont(this.$ctrl.contentFormatsOptions.FONT.selectedFormat);
                this.quillFormatter.setSize(this.$ctrl.contentFormatsOptions.SIZE.selectedFormat);
                this.quillFormatter.setForegroundColor(this.$ctrl.contentFormatsOptions.COLOR.selectedColor);
                this.$ctrl.quillObject.setSelection(0, 0);
            },
            noBrandLogo: function () {
                return !env.get(environment_1.ENV_VARS.BRAND_LOGO);
            },
            useInch: function () {
                return metricImperial.useInch(unit);
            },
            // @ts-ignore
            updateLogoHeight: function (value) {
                this.$ctrl.logoHeight = value;
                this.$ctrl.typeModel.logo.height = this.$ctrl.useInch() ? value : metricImperial.getInchOfCM(value);
            },
            isQuillEditorEnabled: function () {
                return env.get(environment_1.ENV_VARS.FEATURES)[feature_flipper_1.FEATURES.HEADER_FOOTER_PIPED_TEXT];
            }
        });
    }
    // @ts-ignore
    HeaderFooterOptionsController.prototype.addDefaultFormats = function (formatOptions, defaultTextFormats) {
        formatOptions.FONT.selectedFormat = defaultTextFormats.FONT;
        formatOptions.SIZE.selectedFormat = defaultTextFormats.SIZE;
        formatOptions.COLOR.selectedColor = defaultTextFormats.COLOR;
    };
    HeaderFooterOptionsController.$inject = [
        '$scope',
        '$filter',
        'prPageLayoutService',
        'prTextFormatsHelper',
        'rsEnvironment',
        'pr.globalOptionsService',
        'prMetricImperial',
        'prQuillFormatter',
        'prPageHeaderFooterOptionsService',
        'prPipedTextMenuService'
    ];
    return HeaderFooterOptionsController;
}());
(function (angularModule) {
    angularModule.controller('prHeaderFooterOptionsController', HeaderFooterOptionsController);
})(angular_1.module('qualtrics.pr'));
